export const UNKNOWN_ARTIST_NAME = 'Unknown Artist';

/** Display bucket for an album: blank/missing artist tags file under "Unknown Artist". */
export function albumArtistName(album) {
  return String(album?.artist_name ?? '').trim() || UNKNOWN_ARTIST_NAME;
}

/**
 * Albums belonging to an artist-wall entry. Uses the same bucketing as the
 * artist browse index so a count shown on the wall always matches the page.
 * @param {Array<object>} albums
 * @param {string} selectedArtist
 * @param {Set<string>|undefined} variantNames raw tag names grouped under the entry
 */
export function filterAlbumsByArtist(albums, selectedArtist, variantNames) {
  const names = variantNames || new Set([selectedArtist]);
  return (albums || []).filter((a) => names.has(albumArtistName(a)));
}
